export default __webpack_public_path__ + "static/media/goods18.61e56224.gif";